import { FieldSpec } from '@k2/common/k2-forms-state/types';

export function booleanFormatter(field: FieldSpec): string {
  return field.value === true ? 'Yes' : 'No';
}
